import React, { useEffect } from "react";

import useState from "react-usestateref";

// import Pagination from "react-js-pagination";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
import useStyles from "../components/Header/styles";
import moment from "moment";
import Pagination from "@material-ui/lab/Pagination";
import { Box, CircularProgress, Modal, Typography } from "@material-ui/core";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { RxCrossCircled } from "react-icons/rx";

import SearchBar from "./searchbar";

import * as Icons from "@material-ui/icons";
import Skeleton from "react-skeleton-loader";
import ToDatePicker from "./todatepicker";
import FromDatePicker from "./fromdatepicker";
import CsvDownloader from "react-csv-downloader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  border: "none",
  // p: 4,
};

function UnsubmitContact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [getUnsubmitContacts, setgetUnsubmitContacts, getUnsubmitContactsref] =
    useState([]);
  const [totalPage, setTotalpages] = useState(0);
  var classes = useStyles();
  const recordPerPage = 10;
  const totalRecords = 15;
  const pageRange = 5;
  const [open, setOpen] = useState(false);
  const [viewcontact, setviewcontact] = useState("");
  const [pageloader, setpageloader] = useState(true);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [activefilter, setActivefilter] = useState(false);
  const [exportData, setexportData, exportDataref] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.getblockviounsubmitcontacts,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        // return;
        setgetUnsubmitContacts(resp.data.data);
          const formattedData = resp.exportdata.map((item, index) => ({
                  Name: item.userName || "-",
                  "Mobile Number": item.userMobilenumber || "-",
                  "Country Code": item.userCountryCode || "-",
                  Country: item.userCountry,
                  Medium: item.contactMedium,
                  "Medium Value":item.mediumDetail,
                  Message:item.userMessage,
                  Date: item.createdAt
                    ? new Date(moment(item.createdAt).format("lll"))
                    : "-",
                }));
                setexportData(formattedData);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getContacts(1);
  };

  const download = async ()=>{
  if(exportDataref.current.length >0){
  toast.success("Blockvio Unsubmit contacts download succesfully")
  }else{
 toast.error("No record found")
  }
  }
  const deleteContact = async (id) => {
    const result = await Swal.fire({
      title: "Do you really want to delete the Contact ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        var obj = {
          _id: id,
        };
        var data = {
          apiUrl: apiService.deleteblockvioUnubmitcontacts,
          payload: obj,
        };
        var resp = await postMethod(data);
        if (resp.status) {
          toast.success(resp.message);
          getContacts();
        } else {
          toast.error(resp.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div>
        {" "}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Blockvio Unsubmit Contact
          </Typography>
          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term)}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
          <div onClick={download}>
           <CsvDownloader
  filename="Blockvio Unsubmit Contacts"
  extension=".csv"
  separator=","
  wrapColumnChar={`"`}
  datas={exportDataref.current}
  className="csvbutton"
  disabled={!(exportDataref.current?.length > 0)}
>
  <i className="fas fa-file-excel"></i> Export
</CsvDownloader>
</div>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Username </th>
                  <th> Country</th>
                  <th> Country Code </th>
                  <th> Mobile Number</th>
                  <th> Medium </th>
                  <th> Medium Detail </th>
                  <th> Message </th>
                  <th> Date </th>
                  <th> Action </th>
                </tr>
              </thead>

              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : getUnsubmitContactsref.current.length > 0 ? (
                  getUnsubmitContactsref.current &&
                  getUnsubmitContactsref.current.map((orders, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{orders.userName.substring(0, 8)}</td>
                        <td>{orders.userCountry}</td>
                        <td>{orders.userCountryCode}</td>
                        <td>{orders.userMobilenumber}</td>
                        <td>{orders.contactMedium}</td>
                        <td>{orders.mediumDetail}</td>
                        <td className="wrap_unsub">
                          {orders.userMessage.substring(0, 8)}
                        </td>
                        <td>{moment(orders.createdAt).format("lll")}</td>
                        {/* <td className="text-center">
                      <i
                        class="text-danger fa-solid fa-trash unsub_dlt"
                        onClick={() => deleteContact(orders._id)}
                      ></i>
                    </td> */}
                        <td
                          onClick={() => {
                            handleOpen();
                            setviewcontact(orders);
                          }}
                        >
                          <i
                            class="fa-solid fa-eye cursor-pointer"
                            onClick={handleOpen}
                          ></i>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={12}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* <Pagination
        itemClass="page-item"
        linkClass="page-link"
        activePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
        {getUnsubmitContactsref.current.length > 0 ? (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        ) : (
          ""
        )}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_top">
              <h5>Contact Information</h5>
              <RxCrossCircled
                className="modal_close_icon"
                onClick={handleClose}
              />
            </div>
            <div className="modal_bottom">
              <div className="modal_details">
                <h6>Name</h6>
                <p>{viewcontact.userName ? viewcontact.userName : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Mobile Number</h6>
                <p>
                  {viewcontact.userMobilenumber ? viewcontact.userMobilenumber : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Message</h6>
                <p>
                  {viewcontact.userMessage ? viewcontact.userMessage : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Country</h6>
                <p>
                  {viewcontact.userCountry ? viewcontact.userCountry : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Medium</h6>
                <p>
                  {viewcontact.mediumDetail ? viewcontact.mediumDetail : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Message</h6>
                <p>
                  {viewcontact.mediumDetail ? viewcontact.mediumDetail : "--"}
                </p>
              </div>
            </div>
            <div className="d-flex"></div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default UnsubmitContact;
